export const KEYS = {
  ENTER: 'Enter',
} as const
